import { pointInPolygon } from "@nova/calculate-geospatial"
import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import { Coordinate } from "@nova/protobuf"
import {
    selectHotspotMultiSelectFlight,
    selectIsHotspotMultiRemovalOpen,
} from "features/data-management/hotspots/selectors"
import { setSelectedHotspots } from "features/data-management/hotspots/slice"
import { PolygonLayer } from "@deck.gl/layers"
import { selectHotspotsForFlightId } from "panels/hotspot/selectors"
import { useEffect } from "react"
import { useMapDrawingOverlay } from "plugins/shared/useMapDrawingOverlay"
import { getGlobalTerrainData } from "features/map/GlobalTerrainManager"
// import { ImagePreviewContainer } from "plugins/shared/ImagePreviewModal"

export const useRemoveHotspotLayer = () => {
    const dispatch = useAppDispatch()
    const multiRemovalOpen = useAppSelector(selectIsHotspotMultiRemovalOpen)
    const multiSelectFlightId = useAppSelector(selectHotspotMultiSelectFlight)
    const hotspots = useAppSelector(selectHotspotsForFlightId(multiSelectFlightId))

    const { setActive, drawings, clearDrawings } = useMapDrawingOverlay({
        onFinish: (_, allDrawings) => {
            if (!hotspots || !hotspots.length || !multiRemovalOpen) return

            const filtered = hotspots.filter((hotspot) =>
                allDrawings?.some((drawing) => pointInPolygon(hotspot, drawing))
            )
            dispatch(setSelectedHotspots(filtered))
        },
    })

    useEffect(() => {
        setActive(multiRemovalOpen)
        if (!multiRemovalOpen) clearDrawings()
    }, [clearDrawings, drawings, multiRemovalOpen, setActive])

    return [
        new PolygonLayer<Coordinate[]>({
            id: "polygons",
            visible: multiRemovalOpen,
            data: drawings || [],
            getPolygon: (coordinateArray) => {
                return coordinateArray.map((coord) => [coord.longitude, coord.latitude])
            },
            getFillColor: [0, 0, 0, 0],
            getLineColor: [39, 187, 255],
            pickable: true,
            lineWidthUnits: "pixels",
            lineWidthMinPixels: 2,
            lineWidthMaxPixels: 2,
            extensions: [...getGlobalTerrainData().extensions],
        }),
    ]
}
